import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-n20-dialog', {
    attrs: {
      "persistent": "",
      "isOpen": _vm.value,
      "title": _vm.$i18n_t('Dashboards.components.upsertDashboardDialog.title.' + (_vm.dashboard ? 'edit' : 'create')),
      "max-width": "900",
      "action-save-loading": _vm.isSaving,
      "action-save-label": _vm.dashboard ? _vm.$t('Common.save') : _vm.$t('Common.create')
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('input', false);
      },
      "action:save": _vm.save
    }
  }, [_c(VForm, {
    ref: "form",
    model: {
      value: _vm.formValid,
      callback: function ($$v) {
        _vm.formValid = $$v;
      },
      expression: "formValid"
    }
  }, [_c(VRow, [_c(VCol, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('Dashboards.components.upsertDashboardDialog.inputs.name.label'),
      "rules": [_vm.rules.required],
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "required": ""
    },
    model: {
      value: _vm.name,
      callback: function ($$v) {
        _vm.name = $$v;
      },
      expression: "name"
    }
  })], 1)], 1), _c(VRow, [_c(VCol, [_c('core-account-selector', {
    attrs: {
      "disabled": !!_vm.dashboard
    },
    model: {
      value: _vm.tenantId,
      callback: function ($$v) {
        _vm.tenantId = $$v;
      },
      expression: "tenantId"
    }
  })], 1), _c(VCol, [_c('core-dtwin-finder', {
    attrs: {
      "disabled": !_vm.tenantId || _vm.tenantId === -1 || !!_vm.dashboard,
      "label": _vm.$i18n_t('Common.digitalTwins.searchParentLabel'),
      "placeholder": _vm.$i18n_t('Common.digitalTwins.searchParentPlaceholder'),
      "required": "",
      "hideDetails": "",
      "tenant-id": _vm.tenantId,
      "same-tenant": "",
      "skip-tenant-check-for-fetch-of-selected-twin": "",
      "skip-disabled-check-for-fetch-of-selected-twin": ""
    },
    model: {
      value: _vm.parentDtwinId,
      callback: function ($$v) {
        _vm.parentDtwinId = $$v;
      },
      expression: "parentDtwinId"
    }
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };